export function getFirstName(fullName: string): string {
	if (!fullName) return '';

	return fullName.split(' ').slice(0, -1).join(' ');
}

export function getLastName(fullName: string): string {
	if (!fullName) return '';

	return fullName.split(' ').slice(-1).join(' ');
}
